<template>
  <div
    class="flex"
    :class="alignCenter ? 'align-items-center' : 'align-items-start'"
  >
    <div class="relative me-[1rem]">
      <img
        :src="data.avatar_url || 'https://storage.googleapis.com/komerce/assets/avatars/image-null.png'"
        alt="User Profile"
        class="w-[45px] h-[45px] aspect-ratio--1x1 object-cover rounded-circle"
      >
      <span
        v-if="withDotIcon"
        class="dot-icon absolute top-0 right-0"
      />
    </div>
    <div class="w-[50%]">
      <p class="mb-[.25rem] text-black">
        {{ data.talent_name }}
      </p>
      <div class="text-[#737373] m-0">
        <slot name="subTitle" />
      </div>
    </div>
    <span
      v-if="selectedTalentBadge && withBadge"
      class="rounded-full px-[1rem] py-[.25rem] uppercase"
      :class="[selectedTalentBadge, badgeAutoMargin ? 'ms-auto' : 'ms-[.5rem]']"
    >{{ selectedTalentBadgeText }}</span>
  </div>
</template>

<style scoped>
.dot-icon {
  width: 12px;
  height: 12px;
  background-color: #F95031;
  border-radius: 50%;
  border: 1.5px solid #FFFFFF;
  box-shadow: 0 0 0 1px #F95031;
  animation: radar-pulse 1.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  z-index: 10;
}

@keyframes radar-pulse {
  0% {
    box-shadow: 0 0 0 1px #F95031, 0 0 0 0 rgba(249, 80, 49, 0.7);
  }
  70% {
    box-shadow: 0 0 0 1px #F95031, 0 0 0 9px rgba(249, 80, 49, 0);
  }
  100% {
    box-shadow: 0 0 0 1px #F95031, 0 0 0 0 rgba(249, 80, 49, 0);
  }
}

.talent-cs-badge {
    border: 1px solid #D6F1DF;
    background-color: #F4FBF6;
    color: #30A46C;
}

.talent-amp-badge {
    border: 1px solid #FFB088;
    background-color: #FFF4ED;
    color: #F95E16;
}

.talent-ls-badge {
    border: 1px solid #D5EFFF;
    background-color: #F4FAFF;
    color: #0090FF;
}

.talent-adv-badge {
    border: 1px solid #FFDBDC;
    background-color: #FEEBEC;
    color: #E5484D;
}
</style>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    alignCenter: {
      type: Boolean,
      default: false,
    },
    withBadge: {
      type: Boolean,
      default: false,
    },
    badgeAutoMargin: {
      type: Boolean,
      default: true,
    },
    withDotIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      talentBadge: {
        'Customer Service': 'talent-cs-badge',
        'Admin Marketplace': 'talent-amp-badge',
        'Live Streamer': 'talent-ls-badge',
        Advertiser: 'talent-adv-badge',
      },
      talentBadgeText: {
        'Customer Service': 'CS',
        'Admin Marketplace': 'AMP',
        'Live Streamer': 'LS',
        Advertiser: 'ADV',
      },
    }
  },
  computed: {
    selectedTalentBadge() {
      return this.talentBadge[this.data.skill_name] || ''
    },
    selectedTalentBadgeText() {
      return this.talentBadgeText[this.data.skill_name] || ''
    },
  },
}
</script>
